<template>
  <section
    v-if="variants.v1 === variant && blog"
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="container tw-flex tw-items-center tw-self-start tw-px-4 tw-pb-6 tw-pt-20">
      <nuxt-link
        :external="true"
        :to="ROUTES.BLOGS"
        class="n-link tw-flex tw-items-center"
        style="color: var(--c-primary)"
      >
        <div class="tw-mr-2">
          <svg width="28" height="17" viewBox="0 0 28 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M21.875 9.375H6.125C5.635 9.375 5.25 8.99 5.25 8.5C5.25 8.01 5.635 7.625 6.125 7.625H21.875C22.365 7.625 22.75 8.01 22.75 8.5C22.75 8.99 22.365 9.375 21.875 9.375Z"
              fill="var(--c-primary)"
            />
            <path
              d="M10.5 15.5C10.3852 15.5014 10.2715 15.4788 10.166 15.4336C10.0605 15.3883 9.96563 15.3216 9.8875 15.2375L3.7625 9.1125C3.4125 8.7625 3.4125 8.22 3.7625 7.87L9.8875 1.7625C10.2375 1.4125 10.78 1.4125 11.13 1.7625C11.48 2.1125 11.48 2.655 11.13 3.005L5.6175 8.5175L11.13 14.03C11.48 14.38 11.48 14.9225 11.13 15.2725C10.955 15.4475 10.7275 15.535 10.5175 15.535L10.5 15.5Z"
              fill="var(--c-primary)"
            />
          </svg>
        </div>
        <small>BACK TO ALL BLOGS</small>
      </nuxt-link>
    </div>
    <div class="container tw-mt-8 tw-grid tw-grid-cols-12 tw-gap-y-16 lg:tw-gap-x-12">
      <article
        class="blog-detail-content tw-col-span-12 tw-h-fit lg:tw-col-span-7 xl:tw-col-span-8"
        style="border-radius: var(--rounded); background-color: var(--c-section_primary)"
      >
        <div class="tw-mb-10 tw-w-full">
          <NuxtImg
            v-if="blog.media_type === 'image'"
            :src="blog.largeImage"
            loading="lazy"
            :alt="blog.title"
            class="tw-w-full"
            :title="blog.title"
            style="border-radius: var(--rounded)"
            sizes="(max-width: 479px) 92vw, (max-width: 767px) 93vw, (max-width: 1439px) 92vw, 1280px"
            :srcset="`${blog.largeImage} 500w,
                ${blog.largeImage} 800w,
                ${blog.largeImage} 1080w,
               ${blog.largeImage} 1600w,
                ${blog.largeImage} 2500w`"
          />
          <library-iframe v-else-if="blog.media_type === 'video'" :src="blog.video_link"> </library-iframe>
        </div>

        <h2 class="tw-uppercase">{{ blog.title }}</h2>

        <div
          v-if="blog.description"
          style="
            padding: 0 20px;
            color: var(--c-text-primary);
            background-color: var(--c-input);
            border-radius: var(--rounded);
            border-left: 3px solid var(--c-secondary);
          "
          class="tw-my-10"
        >
          <small style="font-size: 16px !important">{{ blog.description }}</small>
        </div>
        <div style="font-family: var(--f-primary) !important">
          <lazy-library-text :html="blog.content" />
        </div>
      </article>

      <div class="tw-col-span-12 lg:tw-col-span-5 xl:tw-col-span-4">
        <div v-if="form" class="tw-mb-6 tw-px-6 tw-py-8" style="border-radius: var(--rounded); background: transparent">
          <library-form :form="form" version="v2" :component="component"></library-form>
        </div>
        <template v-if="sidebarComponents && sidebarComponents.length">
          <div class="sidebar tw-flex tw-flex-col tw-gap-6">
            <available-components-for-sidebar
              key="blog-detail-sidebar"
              key-prefix="blog-detail-sidebar"
              :specific-components="sidebarComponents"
            />
          </div>
        </template>
      </div>
    </div>
  </section>

  <section
    v-if="variants.v2 === variant && blog"
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="container tw-flex tw-items-center tw-self-start tw-px-4 tw-pb-6 tw-pt-20">
      <nuxt-link
        :external="true"
        :to="ROUTES.BLOGS"
        class="n-link tw-flex tw-items-center"
        style="color: var(--c-primary)"
      >
        <div class="tw-mr-2">
          <svg width="28" height="17" viewBox="0 0 28 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M21.875 9.375H6.125C5.635 9.375 5.25 8.99 5.25 8.5C5.25 8.01 5.635 7.625 6.125 7.625H21.875C22.365 7.625 22.75 8.01 22.75 8.5C22.75 8.99 22.365 9.375 21.875 9.375Z"
              fill="var(--c-primary)"
            />
            <path
              d="M10.5 15.5C10.3852 15.5014 10.2715 15.4788 10.166 15.4336C10.0605 15.3883 9.96563 15.3216 9.8875 15.2375L3.7625 9.1125C3.4125 8.7625 3.4125 8.22 3.7625 7.87L9.8875 1.7625C10.2375 1.4125 10.78 1.4125 11.13 1.7625C11.48 2.1125 11.48 2.655 11.13 3.005L5.6175 8.5175L11.13 14.03C11.48 14.38 11.48 14.9225 11.13 15.2725C10.955 15.4475 10.7275 15.535 10.5175 15.535L10.5 15.5Z"
              fill="var(--c-primary)"
            />
          </svg>
        </div>
        <small>BACK TO ALL BLOGS</small>
      </nuxt-link>
    </div>
    <div class="container tw-mt-8 tw-grid tw-grid-cols-12 tw-gap-y-16 lg:tw-gap-x-12">
      <article
        class="tw-col-span-12 tw-h-fit lg:tw-col-span-7 xl:tw-col-span-8"
        style="border-radius: var(--rounded); background-color: var(--c-section_primary)"
      >
        <div class="tw-mb-10 tw-w-full">
          <NuxtImg
            v-if="blog.media_type === 'image'"
            :src="blog.largeImage"
            loading="lazy"
            :alt="blog.title"
            class="tw-w-full"
            :title="blog.title"
            style="border-radius: var(--rounded)"
            sizes="(max-width: 479px) 92vw, (max-width: 767px) 93vw, (max-width: 1439px) 92vw, 1280px"
            :srcset="`${blog.largeImage} 500w,
                ${blog.largeImage} 800w,
                ${blog.largeImage} 1080w,
               ${blog.largeImage} 1600w,
                ${blog.largeImage} 2500w`"
          />
          <library-iframe v-else-if="blog.media_type === 'video'" :src="blog.video_link"> </library-iframe>
        </div>

        <h2 class="tw-uppercase">{{ blog.title }}</h2>

        <div
          v-if="blog.description"
          style="
            padding: 10px 30px;
            color: var(--c-text-primary);
            background-color: var(--c-input);
            border-radius: var(--rounded);
            border-left: 1px solid grey;
            border-right: 1px solid grey;
            border-top: 1px solid grey;
            border-bottom: 1px solid grey;
          "
          class="tw-my-10"
        >
          <small>{{ blog.description }}</small>
        </div>
        <div style="font-family: var(--f-primary) !important; color: var(--c-text_primary) !important">
          <lazy-library-text :html="blog.content" />
        </div>
      </article>

      <div class="tw-col-span-12 lg:tw-col-span-5 xl:tw-col-span-4">
        <div v-if="form" class="tw-mb-6 tw-px-6 tw-py-8" style="border-radius: var(--rounded); background: transparent">
          <library-form :form="form" version="v2" :component="component"></library-form>
        </div>
        <template v-if="sidebarComponents && sidebarComponents.length">
          <div class="sidebar tw-flex tw-flex-col tw-gap-6">
            <available-components-for-sidebar
              key="blog-detail-sidebar"
              key-prefix="blog-detail-sidebar"
              :specific-components="sidebarComponents"
            />
          </div>
        </template>
      </div>
    </div>
  </section>

  <section
    v-if="variants.v3 === variant && blog"
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="container tw-flex tw-items-center tw-self-start tw-px-4 tw-pb-6 tw-pt-20">
      <nuxt-link
        :external="true"
        :to="ROUTES.BLOGS"
        class="n-link tw-flex tw-items-center"
        style="color: var(--c-primary)"
      >
        <div class="tw-mr-2">
          <svg width="28" height="17" viewBox="0 0 28 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M21.875 9.375H6.125C5.635 9.375 5.25 8.99 5.25 8.5C5.25 8.01 5.635 7.625 6.125 7.625H21.875C22.365 7.625 22.75 8.01 22.75 8.5C22.75 8.99 22.365 9.375 21.875 9.375Z"
              fill="var(--c-primary)"
            />
            <path
              d="M10.5 15.5C10.3852 15.5014 10.2715 15.4788 10.166 15.4336C10.0605 15.3883 9.96563 15.3216 9.8875 15.2375L3.7625 9.1125C3.4125 8.7625 3.4125 8.22 3.7625 7.87L9.8875 1.7625C10.2375 1.4125 10.78 1.4125 11.13 1.7625C11.48 2.1125 11.48 2.655 11.13 3.005L5.6175 8.5175L11.13 14.03C11.48 14.38 11.48 14.9225 11.13 15.2725C10.955 15.4475 10.7275 15.535 10.5175 15.535L10.5 15.5Z"
              fill="var(--c-primary)"
            />
          </svg>
        </div>
        <small>BACK TO ALL BLOGS</small>
      </nuxt-link>
    </div>
    <div class="container tw-mt-8 tw-grid tw-grid-cols-12 tw-gap-y-16 lg:tw-gap-x-12">
      <article
        class="tw-col-span-12 tw-h-fit lg:tw-col-span-7 xl:tw-col-span-8"
        style="border-radius: var(--rounded); background-color: var(--c-section_primary)"
      >
        <div class="tw-mb-10 tw-w-full">
          <NuxtImg
            v-if="blog.media_type === 'image'"
            :src="blog.largeImage"
            loading="lazy"
            :alt="blog.title"
            class="tw-w-full"
            :title="blog.title"
            style="border-radius: var(--rounded)"
            sizes="(max-width: 479px) 92vw, (max-width: 767px) 93vw, (max-width: 1439px) 92vw, 1280px"
            :srcset="`${blog.largeImage} 500w,
                ${blog.largeImage} 800w,
                ${blog.largeImage} 1080w,
               ${blog.largeImage} 1600w,
                ${blog.largeImage} 2500w`"
          />
          <library-iframe v-else-if="blog.media_type === 'video'" :src="blog.video_link"> </library-iframe>
        </div>

        <h2 class="tw-uppercase">{{ blog.title }}</h2>

        <div
          v-if="blog.description"
          style="
            padding: 10px 30px;
            color: var(--c-text-primary);
            background-color: var(--c-input);
            border-radius: var(--rounded);
            border-left: 3px solid var(--c-primary);
          "
          class="tw-my-10"
        >
          <small>{{ blog.description }}</small>
        </div>
        <div style="font-family: var(--f-primary) !important; color: var(--c-text_primary) !important">
          <lazy-library-text :html="blog.content" class="tw-space-y-4" />
        </div>
      </article>

      <div class="tw-col-span-12 lg:tw-col-span-5 xl:tw-col-span-4">
        <div v-if="form" class="tw-mb-6 tw-px-6 tw-py-8" style="border-radius: var(--rounded); background: transparent">
          <library-form :form="form" version="v2" :component="component"></library-form>
        </div>
        <template v-if="sidebarComponents && sidebarComponents.length">
          <div class="sidebar tw-flex tw-flex-col tw-gap-6">
            <available-components-for-sidebar
              key="blog-detail-sidebar"
              key-prefix="blog-detail-sidebar"
              :specific-components="sidebarComponents"
            />
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import type { Component } from '~/types';
import { ComponentMixin } from '~/mixins/component.mixin';
import { BlogMixin } from '~/units/blogs/mixins/blog.mixin';
import { useBlogsStore } from '~/units/blogs/store';
import { ROUTES } from '~/constants/ui.constants';
import AvailableComponentsForSidebar from '~/components/theme7/AvailableComponentsForSidebar.vue';
import { mapState } from 'pinia';
import { useWebsiteStore } from '~/units/website/store';

export default defineNuxtComponent({
  name: 'Theme7BlogDetail',

  mixins: [ComponentMixin, BlogMixin],

  components: { AvailableComponentsForSidebar },

  data() {
    return { form: null, variants: { v1: 'v1', v2: 'v2', v3: 'v3' } };
  },

  created() {
    this.form = this.parseFormV2(this.vars.blogForm);
  },

  async setup(props: { component: Component }) {
    const blogsStore = useBlogsStore();
    await blogsStore.fetchSingleBlog(props.component);
  },

  computed: {
    ...mapState(useWebsiteStore, ['sidebarComponents']),

    ROUTES() {
      return ROUTES;
    },
  },
});
</script>

<style scoped>
.blog-detail-content ::v-deep(*) {
  font-family: var(--f-primary) !important;
  color: var(--c-text-primary) !important;
}

.blog-detail-content ::v-deep(a) {
  padding: 0 !important;
}

.blog-detail-content ::v-deep(iframe) {
  max-width: 100%;
}
</style>
